import React, { useState, useEffect, createContext, useContext } from 'react';

const SongSaveDataContext = createContext();
const SongSaveDataUpdateContext = createContext();


export function SongSaveDataProvider({ children, initialData }) {
  const [songSaveData, setSongSaveData] = useState(initialData);

  // Provide an update function that external scripts can call
  const updateSongSaveData = (newData) => {
    setSongSaveData(newData);
    //console.log("NEW:\n" + JSON.stringify(newData, null, 4));
  };

  return (
    <SongSaveDataContext.Provider value={songSaveData}>
      <SongSaveDataUpdateContext.Provider value={updateSongSaveData}>
        {children}
      </SongSaveDataUpdateContext.Provider>
    </SongSaveDataContext.Provider>
  );
}

export function useSongSaveData() {
  return useContext(SongSaveDataContext);
}

export function useUpdateSongSaveData() {
  return useContext(SongSaveDataUpdateContext);
}


function Tag({ key, songId, tag, name, onSelect, selected }) {
  //let [status, setStatus] = useState(0);
  return (
    <div
      onClick={() => { onSelect(tag) }}
      className="tag-box" style={{
        fontSize: "2.2em",
        backgroundColor: (selected) ? "cornflowerblue" : "lightgrey", borderRadius: 5, borderWidth: 3, borderColor: "grey", margin: "40", padding: "40"
      }} >
      <span style={{ color: (selected) ? "black" : "white" }}>{" " + name + " "}</span>
      {(selected) ? <button className="tag-delete" style={{}} onClick={() => { onSelect(tag) }}>×</button> : <button className="tag-add" onClick={() => { onSelect(tag) }}>+</button>}
    </div>
  );
}

function TagAdder({ category, onAdd, songId, options }) {
  const [newTag, setNewTag] = React.useState('');
  let [addableTags, setAddableTags] = useState(options);
  let [addedTags, setAddedTags] = useState({});

  const [newValue, setNewValue] = useState('');

  if (options == undefined) {
    options = {};
  }

  const handleAdd = () => {
    if (newTag.trim()) {
      //onAdd(newTag.trim());
      //setNewTag('');
      getAddableTags();
    }
  };

  const getAddableTags = () => {
    //console.log("GETTING ADDABLE TAGS");
    //console.log("OPTIONS:" + Object.keys(options).length);
    let addableTags0 = {};
    for (let tag in options) {
      let tagName = options[tag];
      if (tagName.indexOf(",") != -1)
        tagName = tagName.split(",")[0];
      tagName = tagName.toLowerCase().trim();
      if (newTag != "" && newTag.length > 1 && !(tag in addedTags) && (tagName.includes(newTag.toLowerCase()))) {
        addableTags0[tag] = options[tag];
      }
    }




    setAddableTags(addableTags0);
  }

  const addTag = (tag) => {
    //onAdd(tag);
    let addedTags0 = addedTags;
    addedTags0[tag] = options[tag];
    setAddedTags(addedTags0);

    let addableTags0 = {}; // addableTags;
    delete addableTags0[tag];
    //setAddableTags(addableTags0);

    setNewTag('');
  }

  if (options == undefined || Object.keys(options).length == 0) {
    return (
      <div className="tag-adder" >
        <input
          type="text"
          style={{ width: "93%" }}
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          placeholder={``}
        />
      </div>
    );
  }
  else

    return (
      <div className="tag-adder" >
        <input
          type="text"
          style={{ width: "93%" }}
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          placeholder={`Create a new tag`}
        />

        <button className='btn' style={{ width: "100%" }} onClick={handleAdd} > Add the new tag </button>


        <div>
          <div className="tag-list" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>

            {Object.entries(addedTags).map(([tag, name]) => (
              <div style={{ padding: "20px" }}>
                <Tag
                  key={tag + songId}
                  type="a"
                  selected={true}
                  tag={tag}
                  name={name}
                  onAdd={() => { addTag(tag); onAdd(tag) }}
                />
              </div>
            ))}
          </div>
          <div className="tag-list" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>

            {Object.entries(addableTags).map(([tag, name]) => (
              <div style={{ padding: "20px" }}>
                <Tag
                  key={tag + songId}
                  type="a"
                  tag={tag}
                  name={name}
                  onAdd={() => { addTag(tag); onAdd(tag) }}
                />
              </div>
            ))}
          </div>


        </div>


      </div>
    );
}

function TagCategory({ category, tags, options, songId, onSelect }) {

  //order by name
  let orderedTags = Object.keys(options).slice().sort((a, b) => {
    if (tags.includes(a) && !tags.includes(b)) return -1;
    if (!tags.includes(a) && tags.includes(b)) return 1;
    let nameA = options[a] || a;
    let nameB = options[b] || b;
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
  //console.log("ORDERED TAGS:", orderedTags);

  return (
    <div class="form-group">
      <label> {category} </label>
      <div className="tag-list" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>

        {orderedTags.map((tag) => (
          <div style={{ padding: "20px" }}>
            <Tag
              key={tag + songId}
              songId={songId}
              tag={tag}
              name={options[tag] || tag}
              onSelect={(tag) => onSelect(tag)}
              selected={tags.includes(tag)}
            />
          </div>
        ))}
      </div>
      {/* <TagAdder key={"add" + category + songId} category={category} onAdd={onAddTag} songId={songId} options={options} /> */}
    </div>
  );
}


function SongSaveEditor({ songId, onSave, currentTimeStamp, onTest, onStopTest }) {
  const songSaveData = useSongSaveData();
  const [newTag, setNewTag] = useState('');
  const [tags, setTags] = useState(songSaveData.tags || { "t": [] });
  //console.log("Rendering SongSaveEditor with data:", JSON.stringify(songSaveData, null, 4), "and tags:", JSON.stringify(tags, null, 4));
  const [startTime, setStartTime] = useState(songSaveData.startTime || "");
  const [stopTime, setStopTime] = useState(songSaveData.stopTime || "");
  const [options, setOptions] = useState(songSaveData.options || { "t": {} });

  useEffect(() => {
    setTags(songSaveData.tags || { t: [] });
    setOptions(songSaveData.options || { "t": {} });
    setStartTime(songSaveData.startTime || "");
    setStopTime(songSaveData.stopTime || "");
  }, [songSaveData]);

  const onSelectTag = (tag) => {
    console.log(`Selected tag '${tag}' for song '${songId}'`);
    let newTags = { "t": [] };
    let foundTag = false;
    for (let t of tags.t) {
      if (t == tag) {
        foundTag = true;
      }
      else {
        newTags.t.push(t);
      }
    }
    if (!foundTag)
      newTags.t.push(tag);

    console.log("NEW TAGS:", newTags);

    setTags(newTags);
    //onSave(serializeData());
  }





  return (
    <div className="song-save-editor">
      {/*<h2>Edit Song Save Data</h2>*/}
      <div class="form-card" style={{ marginTop: "20px", width: "620px", marginBottom: "20px" }}>
        <h2> Advanced Save Options </h2>
        <div className="tags-section">

          {Object.entries(tags).map(([category, ttags]) => (

            <TagCategory
              key={category + songSaveData.id}
              songId={songSaveData.id}
              options={options["t"] || {}}
              category={songSaveData.categories[category] || category}
              onSelect={onSelectTag}
              tags={ttags || []}
            />

          ))}
        </div>

        <div class="form-group">
          <label> Add a tag</label>
          <div className="tag-adder" style={{ display: "flex", flexDirection: "row", alignItems: "center" }} >
            <input
              type="text"
              style={{ width: "63%" }}
              value={newTag}
              onChange={(e) => {
                setNewTag(e.target.value);
              }}
              placeholder={`Add a tag`}
            />
            <button className='button2' style={{ padding: "5px 5px", marginBottom: "10px", marginTop: "10 px", fontSize: "40px", width: "30%" }}
              onClick={() => {
                let addedTag = newTag.trim();
                if (addedTag != "") {
                  let optionsValues = Object.values(options["t"]);
                  if (!(optionsValues.includes(addedTag))) {
                    let numOptions = "" + Object.keys(options["t"]).length;
                    options["t"][numOptions] = addedTag;
                    setOptions({ ...options });
                    onSelectTag(numOptions);
                  }

                  setNewTag('');
                }
              }

              }> Add </button>
          </div>
        </div>


        <div style={{ height: "20px" }}></div>

        <div class="form-group">
          <label> Start Time</label>
          <div className="tag-adder" style={{ display: "flex", flexDirection: "row", alignItems: "center" }} >
            <input
              type="text"
              style={{ width: "63%" }}
              value={startTime}

              onChange={(e) => {
                console.log("START TIME CHANGED:", e.target.value);
                setStartTime(e.target.value);
                //let serializedData = serializeData();
                //console.log("Serialized data on start time change:", serializedData);
                //onSave(serializedData);
              }}
              placeholder={`When to start (in seconds)`}
            />
            <button className='button2' style={{ padding: "5px 5px", marginBottom: "10px", marginTop: "10 px", fontSize: "40px", width: "30%" }}
              onClick={() => setStartTime(Math.floor(currentTimeStamp()))

              }> {"⇦"} Video </button>
          </div>
        </div>
        <div style={{ height: "20px" }}></div>

        <div class="form-group">
          <label> Stop Time</label>
          <div className="tag-adder" style={{ display: "flex", flexDirection: "row", alignItems: "center" }} >
            <input
              type="text"
              style={{ width: "63%" }}
              value={stopTime}
              onChange={(e) => {
                console.log("STOP TIME CHANGED:", e.target.value);
                setStopTime(e.target.value);
                //let serializedData = serializeData();
                //console.log("Serialized data on stop time change:", serializedData);
                //onSave(serializedData);
              }}
              placeholder={`When to stop (in seconds)`}
            />
            <button className='button2' style={{ padding: "5px 5px", marginBottom: "10px", marginTop: "10 px", fontSize: "40px", width: "30%" }}
              onClick={() => setStopTime(Math.floor(currentTimeStamp()))

              }> {"⇦"} Video </button>
          </div>
        </div>


        <br />
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
          <button id="saveSongButton" className='button2' style={{ padding: "5px 5px", marginBottom: "40px", marginTop: "20 px", fontSize: "40px" }}
            onClick={() => onTest(startTime, stopTime)}>
            Test Loop
          </button>

          <button id="saveSongButton" className='button2' style={{ padding: "5px 5px", marginBottom: "40px", marginTop: "20 px", fontSize: "40px" }}
            onClick={() => onStopTest()}>
            Stop Loop
          </button>
        </div>
        <br />
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
          <button id="saveSongButton" className='button2' style={{ padding: "5px 5px", marginBottom: "40px", marginTop: "20 px", fontSize: "40px" }}
            onClick={() => onSave({ options: options, tags: tags, startTime: startTime, stopTime: stopTime }) //window.saveSong()

            }>
            Save
          </button>

        </div>

      </div>


    </div>
  );
}

export default SongSaveEditor;
